// SPDX-License-Identifier: AGPL-3.0-or-later

import {DaoIWallet, type InjectedWallet} from '@app/features/daoi/bridge/DaoIWallet';

export async function connectPrivyBusinessWallet(
	provider: InjectedWallet,
	address: string,
	active: () => boolean = () => true,
): Promise<void> {
	const accounts = await provider.request({method: 'eth_accounts'});
	if (
		!active() ||
		!Array.isArray(accounts) ||
		typeof accounts[0] !== 'string' ||
		accounts[0].toLowerCase() !== address.toLowerCase() ||
		DaoIWallet.boundAddress?.toLowerCase() !== address.toLowerCase()
	) {
		throw new Error('当前钱包与账号绑定地址不同，请恢复原钱包。');
	}
	await DaoIWallet.connect(provider, false, active);
	if (!active() || !DaoIWallet.matchesBound) {
		throw new Error('钱包状态已变化，请重新恢复原钱包。');
	}
}
